module.exports = __webpack_public_path__ + "media/images/sec_5-check-bb02d6eeb271299ec395e9c9d66d3458.png";